import { BillingContractWithServiceContracts, Product, PRODUCTS } from '@boltenergy-be/shared'
import { ProductSwitchInputs } from 'pages/app/tariffs/products/components/product-switch-modal/types.ts'
import { checkIsMonthlyBilling } from 'utils/smartBillingOptions.ts'
import { MonthlyBillingEligibility } from 'types/smartBillingOptions.ts'

/**
 * Check if the product is disabled or not
 * @param {Product} product
 * @param {Product[]} usableProducts
 * @returns {boolean}
 */
export const checkProductIsDisabled = (product: Product, usableProducts: Product[]): boolean => {
  const isUnavailableProduct = !usableProducts.includes(product)

  return ([PRODUCTS.earlyBirdOnline, PRODUCTS.earlyBirdOffline] as Product[]).includes(product) || isUnavailableProduct
}

/**
 *
 * @param {BillingContract["serviceContracts"]} serviceContracts
 * @param {MonthlyBillingEligibility} isMonthlyBillingEligible
 * @returns {Array<"monthlyBilling" | "dynamicTariff">}
 */
export const determineCurrentSmartMeterOptions = (
  serviceContracts: BillingContractWithServiceContracts['serviceContracts'],
  isMonthlyBillingEligible: MonthlyBillingEligibility
): ProductSwitchInputs['smartMeterOptions'] => {
  const isDynamicTariff = serviceContracts.electricity.detail.dynamicTariff
  const isMonthlyBilling = checkIsMonthlyBilling(isMonthlyBillingEligible, serviceContracts.electricity, serviceContracts.gas)
  const options: ProductSwitchInputs['smartMeterOptions'] = []

  if (isMonthlyBilling) options.push('monthlyBilling')
  if (isDynamicTariff) options.push('dynamicTariff')

  return options
}
